<template>
  <section>
    <!-- ROUTER CONTENT SHOULD GO HERE -->
    <div class="container-fluid border-bottom">
      <div class="row align-items-center">
        <div class="col-md-6 p-0">
          <img
            src="@/assets/img/_bg/job-search-bkrnd.jpg"
            class="img-fluid"
            alt=""
            srcset=""
          >
        </div>
        <div class="col-md-6 p-5">
          <h1>
            <img
              src="@/assets/img/_title/0-job-search.svg"
              alt="JOB SEARCH"
              class="img-fluid"
            >
          </h1>
          <p>Learn some tips and tricks for finding a great on-campus job to apply to</p>
        </div>
      </div>
    </div>

    <div class="pt-5 px-4">
        <div class="container-fluid">
          <div class="row">
            <!-- ITERATE THROUGH MENU ITEMS -->
            <div
              class="col-md-4 routing-nav my-3"
              v-for="menuItem in $store.state.jobSearch"
              :key="menuItem.category"
            >
              <router-link
                :to="menuItem.route"
                append
                class="routing-nav__btn routing-nav__btn--green"
              >
                <div class="routing-nav__title">{{menuItem.name}}</div>
                <!-- <p>{{menuItem.description}}</p> -->
                <div class="routing-nav__cta">Learn more</div>
              </router-link>
            </div>

            <!-- IMG -->
            <div class="col-md my-3">
                <img src="@/assets/img/_content/1.Job_Search_menu-long.png" alt="" class="img-fluid w-100">
            </div>
          </div>
        </div>
    </div>
  </section>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      hooperSettings: {
        itemsToShow: 1,
        trimWhiteSpace: true,
        centerMode: false,
        wheelControl: false,
        breakpoints: {
          1024: {
            itemsToShow: 3
          }
        }
      }
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
